import { useDispatch } from 'react-redux'
import { MarkerTypeInput as Input, useLayoutEffect } from 'ui-components'

import { useCategoryOptions } from '~map-preview/states/map'
import {
  MARKER_TYPES,
  setCategory,
  setType,
  useMarkerCategory,
  useMarkerType,
  useMarkerTypeOptions
} from '~map-preview/states/marker'
import { closeMapLegend, openMapLegend } from '~map-preview/states/ui'

function MarkerTypeInput() {
  const dispatch = useDispatch()

  const value = useMarkerType()
  const category = useMarkerCategory()
  const options = useMarkerTypeOptions()
  const categoryOptions = useCategoryOptions()

  const handleChange = (event, value) => {
    dispatch(setType(value))
    if (!category) dispatch(setCategory(categoryOptions[0]?.value))
  }

  useLayoutEffect(() => {
    if (value === MARKER_TYPES.CATEGORIES) dispatch(openMapLegend())
    else dispatch(closeMapLegend())
  }, [dispatch, value])

  return (
    <Input
      options={options}
      value={value}
      onChange={handleChange}
    />
  )
}

export { MarkerTypeInput }
